import { useQuery } from 'react-query';
import NegotiationService from '../../../services/NegotiationService';
import { Components } from '../../../global.d';
import { LIST } from '../../constants/queryDefinition';

const useAuctionNegotiation = (
  auctionId: number,
  callApi: boolean = true
): Components.Schemas.NegotiationListResponse => {
  const customSort = (
    proposals: Components.Schemas.NegotiationProposal[]
  ): void => {
    proposals.sort((a, b) => {
      if (a?.id < b?.id) {
        return -1;
      }
      if (a?.id > b?.id) {
        return 1;
      }
      return 0;
    });
  };

  const getNegotiationForAuction = async () => {
    const negotiationService = NegotiationService.get();
    return negotiationService.getProposals(auctionId);
  };

  const negotiationResponse = useQuery(
    `${LIST.SELLPENDING.PROPOSALS}-${auctionId}`,
    getNegotiationForAuction,
    {
      enabled: callApi && Boolean(auctionId),
      refetchOnMount: 'always'
    }
  );

  // Mobile has some dependencies on proposals[0]. So we'll have to make do with a manual sort here.
  customSort(negotiationResponse?.data?.proposals || []);

  return negotiationResponse?.data;
};

export default useAuctionNegotiation;
